module.exports = __webpack_public_path__ + "img/oilApk.9363577c.png";